import React, { useMemo, useState } from "react";
import { Form, Select } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { GET_SUBCONTRACTOR_CURSOR } from "graphql/query/subcontractor-gql";
import { cursorPagination, Localize } from "components/service";
import { useDebounce } from "components/use-hooks";


const StaffAuditSubcontractorSelect = ({
    form,
    name = "subcontractor_id",
    selected = false,
    onChange = () => {},
}) => {
    const [ searchText, setSearchText ] = useState("");
    const searchSubcontractorLabel = Localize({
        children: "SEARCH.Input_Placeholder_Subcontractor",
    }).props.children;
    const { data, loading, fetchMore } = useQuery(GET_SUBCONTRACTOR_CURSOR, {
        variables: {
            text: useDebounce(searchText),
            first: 25,
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
    });
    const { nodes, onPopupScroll } = cursorPagination({
        model: "subcontractorsCursor",
        data,
        loading,
        fetchMore,
    });

    const options = useMemo(() => nodes.map((item) => ({
        value: String(item.value),
        label: item.label,
    })), [ nodes ]);

    return (
        <Form.Item name={ name } noStyle>
            <Select
                allowClear
                aria-label={ searchSubcontractorLabel }
                clearIcon={ <CloseOutlined /> }
                showArrow
                showSearch
                className={ `staff-audit-filter__subcontractor${
                    selected ? " staff-audit-filter__subcontractor--chosen staff-filter-control--selected" : ""
                }` }
                dropdownClassName="staff-audit-filter__dropdown"
                filterOption={ false }
                loading={ loading }
                options={ options }
                placeholder={ searchSubcontractorLabel }
                suffixIcon={ selected ? null : <SearchOutlined /> }
                onPopupScroll={ onPopupScroll }
                onSearch={ setSearchText }
                onChange={ (value) => {
                    form.setFieldsValue({ [ name ]: value });
                    onChange(value);
                } } />
        </Form.Item>
    );
};

export default StaffAuditSubcontractorSelect;
